import { Button } from '@journ/ui/button'
import { useIntlayer } from 'react-intlayer'
import { openSheet } from '@/features/ui/store'
import { useCustomerParams } from './use-customer-params'
import { GLOBAL_SHEET_IDS } from '@/features/ui/hooks/use-sheet'

const EmptyState = () => {
	const content = useIntlayer('customers-page')

	return (
		<div className='flex items-center justify-center'>
			<div className='flex flex-col items-center mt-40'>
				<div className='text-center mb-6 space-y-2'>
					<h2 className='font-medium text-lg'>{content.empty.title}</h2>
					<p className='text-606060 text-sm'>{content.empty.description}</p>
				</div>
				<Button variant='outline' onClick={() => openSheet(GLOBAL_SHEET_IDS.CUSTOMER_CREATE)}>
					{content.empty.action}
				</Button>
			</div>
		</div>
	)
}

const NoResults = () => {
	const content = useIntlayer('customers-page')
	const { setParams } = useCustomerParams()

	return (
		<div className='flex items-center justify-center'>
			<div className='flex flex-col items-center mt-40'>
				<div className='text-center mb-6 space-y-2'>
					<h2 className='font-medium text-lg'>{content.noResults.title}</h2>
					<p className='text-606060 text-sm'>{content.noResults.description}</p>
				</div>
				<Button variant='outline' onClick={() => setParams({ q: null })}>
					{content.noResults.action}
				</Button>
			</div>
		</div>
	)
}

export { EmptyState, NoResults }
